var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase } from "./reactquestion_element";
import { SurveyRowElement } from "./element";
import { ReactElementFactory } from "./element-factory";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
var SurveyRow = /** @class */ (function (_super) {
    __extends(SurveyRow, _super);
    function SurveyRow(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        _this.recalculateCss();
        return _this;
    }
    SurveyRow.prototype.recalculateCss = function () {
        this.row.visibleElements.map(function (element) { return element.cssClasses; });
    };
    SurveyRow.prototype.getStateElement = function () {
        return this.row;
    };
    Object.defineProperty(SurveyRow.prototype, "row", {
        get: function () {
            return this.props.row;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyRow.prototype, "survey", {
        get: function () {
            return this.props.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyRow.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyRow.prototype, "css", {
        get: function () {
            return this.props.css;
        },
        enumerable: false,
        configurable: true
    });
    SurveyRow.prototype.canRender = function () {
        return !!this.row && !!this.survey && !!this.creator;
    };
    SurveyRow.prototype.renderElementContent = function () {
        var _this = this;
        var elements = this.row.visibleElements.map(function (element, elementIndex) {
            return (React.createElement(SurveyRowElement, { element: element, index: elementIndex, row: _this.row, survey: _this.survey, creator: _this.creator, css: _this.css, key: element.id }));
        });
        return (React.createElement("div", { ref: this.rootRef, className: this.row.getRowCss() }, elements));
    };
    SurveyRow.prototype.renderElement = function () {
        var survey = this.survey;
        var content = this.renderElementContent();
        var wrapper = ReactSurveyElementsWrapper.wrapRow(survey, content, this.row);
        return wrapper || content;
    };
    SurveyRow.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var el = this.rootRef.current;
        if (this.rootRef.current) {
            this.row.setRootElement(this.rootRef.current);
        }
        if (!!el && !this.row.isNeedRender) {
            var rowContainerDiv = el;
            this.lazyRenderingTimeout = setTimeout(function () {
                _this.row.startLazyRendering(rowContainerDiv);
            }, 10);
        }
    };
    SurveyRow.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        if (nextProps.row !== this.row) {
            nextProps.row.isNeedRender = this.row.isNeedRender;
            nextProps.row.setRootElement(this.rootRef.current);
            this.row.setRootElement(undefined);
            this.stopLazyRendering();
        }
        this.recalculateCss();
        return true;
    };
    SurveyRow.prototype.stopLazyRendering = function () {
        clearTimeout(this.lazyRenderingTimeout);
        this.row.stopLazyRendering();
        this.row.isNeedRender = !this.row.isLazyRendering();
    };
    SurveyRow.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.row) {
            if (!this.row.hasActiveUISubscribers) {
                this.row.setRootElement(undefined);
                this.stopLazyRendering();
            }
        }
    };
    SurveyRow.prototype.createElement = function (element, elementIndex) {
        var index = elementIndex ? "-" + elementIndex : 0;
        var elementType = element.getType();
        if (!ReactElementFactory.Instance.isElementRegistered(elementType)) {
            elementType = "question";
        }
        return ReactElementFactory.Instance.createElement(elementType, {
            key: element.name + index,
            element: element,
            creator: this.creator,
            survey: this.survey,
            css: this.css,
        });
    };
    return SurveyRow;
}(SurveyElementBase));
export { SurveyRow };
